import React, { Component } from 'react';
import HeaderTags from '../../common/headerTags/HeaderTags';
import Artists from '../../components/artists/index';
import { fetchDataArtistsIfNeeded } from '../../components/artists/actions/ArtistsActions';
import { fetchLatestVideosIfNeeded } from '../../components/videos/actions/videosSliderActions';
import { fetchAlbumSlidesIfNeeded } from '../../components/artists/actions/AlbumsSliderActions';
// import SupportingText from '../../common/supportingText/SupportingText';

const headerTags =
    {
        title: 'Artistas - Notícias, músicas, lançamentos e muito mais', // | Antena 1 is automatically added by the Headers Tag
        meta: {
            description: 'Fique por dentro de todas as notícias, curiosidades e lançamentos musicais dos melhores artistas internacionais do passado e do presente. Acesse o portal Antena 1!',
            keywords: 'notícias, biografia, discografia, música, vídeos, álbuns, avicii, celine dion, abba, james blunt, katy perry, kendrick lamar, passenger, pharrell williams, rita ora, pink, bee gees',
            'og:title': 'Artistas - Notícias, músicas, lançamentos e muito mais',
            'og:description': 'Fique por dentro de todas as notícias, curiosidades e lançamentos musicais dos melhores artistas internacionais do passado e do presente. Acesse o portal Antena 1!',
            'og:image': 'https://a1media.antena1.com.br/image/share/artistas.png',
        },
    };
// const supportingTextInfo = {
//     title: 'Os grandes cantores e cantoras',
//     description: `Dos anos de 1960, 1970, 1980, 1990, 2000 e 2010 você encontra aqui na Rádio Antena 1.
//         Fique por dentro da biografia dos seus artistas favoritos, desde os primeiros contatos com a música, os shows, acontecimentos pessoais e profissionais e toda a discografia e canções lançadas.
//         Justin Timberlake, Christina Aguilera, Michael Jackson, Madonna, Bob Marley, Barbra Streisand, Aretha Franklin, Bob Dylan, Elvis Presley e Jennifer Lopez são apenas alguns artistas que você vai ler sobre a carreira pessoal e profissional.
//         Baixe também o nosso aplicativo e ouça o seu artista favorito, além de outro grandes sucessos do mundo da música. Disponível nas lojas virtuais da Apple Store e Google Play.`,
// };

class Artistas extends Component {
    static fetchData(store) {
        const myPromises = [
            store.dispatch(fetchDataArtistsIfNeeded()), // fetchDataArtistsIfNeeded will also set the data for the artistsSlider!
            store.dispatch(fetchAlbumSlidesIfNeeded(20)),
            store.dispatch(fetchLatestVideosIfNeeded(5)),
        ];

        return Promise.all(myPromises);
    }

    render() {
        return (
            <div className="pageWrapper tw-container tw-m-auto tw-px-5">
                <HeaderTags title={headerTags.title} meta={headerTags.meta} />
                <Artists />
                {/* <SupportingText title={supportingTextInfo.title} description={supportingTextInfo.description} /> */}
            </div>
        );
    }
}

export default Artistas;
